export const CHANGE_LIST_OPEN_MODAL = "CHANGE_LIST_OPEN_MODAL"
export const CHANGE_LIST_SEARCH_REQUEST = "CHANGE_LIST_SEARCH_REQUEST"
export const CHANGE_LIST_SEARCH_RESULT = "CHANGE_LIST_SEARCH_RESULT"
export const CHANGE_LIST_SEARCH_SUBUSERS_REQUEST = "CHANGE_LIST_SEARCH_SUBUSERS_REQUEST"
export const CHANGE_LIST_SEARCH_SUBUSERS_RESULT = "CHANGE_LIST_SEARCH_SUBUSERS_RESULT"